<template>
  <div>
    <logged-in-header />
    <purchases />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import purchases from "../components/purchases/Purchases";

export default {
  components: {
    loggedInHeader,
    purchases
  }
};
</script>
